import { CUSTOMER_ACCOUNT_GM_GET_POINTS } from 'Utils/request/requestDictionary';
import gqlClient from 'Utils/graphql-client/graphqlClient';
export const getPointsFromAmount = ({
  amount,
  appContext,
  duration,
}: {
  amount: string;
  appContext: AppContext;
  duration: string;
}) => {
  const query = `
      query {
        loyaltyProgramSimulation {
          points(spentAmount: ${amount}, durationInNights: ${duration})
        }
      }
    `;
  return gqlClient.runNoCacheQuery(query, appContext, {
    requestName: CUSTOMER_ACCOUNT_GM_GET_POINTS,
  });
};
